module.exports = __webpack_public_path__ + "static/media/avatar-3.7ce49759.jpg";